module.exports = __webpack_public_path__ + "img/turk2.da0cf97a.jpg";